export default "__VITE_ASSET__d51a06e4__"